import { render, staticRenderFns } from "./SubOrdersToDispatch.vue?vue&type=template&id=b3081a94&scoped=true&"
import script from "./SubOrdersToDispatch.vue?vue&type=script&lang=js&"
export * from "./SubOrdersToDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3081a94",
  null
  
)

export default component.exports